const featuresPay = {
    featureTitle: 'Prendi Decisioni Aziendali Basate sui Dati',
    featureDescription:
        'Scopri quali articoli si vendono di più e generano maggiore profitto, e accedi ai report finanziari in qualsiasi momento e ovunque. La tua attività a portata di mano!',
    featureButton: "Abbonamento Premium",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'A partire da',
    featureEndingText: 'Mila',

    features: [
        {
            title: 'Articoli Illimitati',
            description: 'Aggiungi tutti gli articoli che possiedi senza limiti.'
        },
        {
            title: 'Personale Illimitato',
            description: "Aggiungi personale/amministratori all'azienda senza limiti."
        },
        {
            title: 'Cronologia Illimitata',
            description: 'Visualizza le modifiche nei vecchi registri di magazzino senza limiti.'
        },
        {
            title: 'Filtro Cronologia',
            description: 'Visualizza facilmente la cronologia in base a tipo, categoria, personale e data.'
        },
        {
            title: 'Download in Excel',
            description: 'Esporta la cronologia dei registri di magazzino in Microsoft Excel con un solo clic.'
        },
        {
            title: 'Download in PDF',
            description: "Ottieni l'elenco degli articoli e delle scorte più recenti in PDF con un solo clic."
        }
    ],
    warehousesGuide: [
        {
            desc: 'Crea più magazzini per una migliore gestione delle scorte.'
        },
        {
            desc: 'Assegna i prodotti a posizioni specifiche.'
        },
        {
            desc: 'Monitora i livelli di inventario tra i magazzini.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Aggiungi varianti per taglia, colore o materiale.' },
        { desc: 'Imposta i livelli di scorta per variante.' },
        { desc: 'Traccia le varianti tra i magazzini.' }
    ]
}

export default featuresPay
